export default {
    whichWill: {
        title: '哪種平安紙服務最適合我 | {{country}}',
        description: '回答一些問題，找出最適合您需求的平安紙服務。',
        keywords: '香港平安紙服務選擇，問卷，最適合我',
        whichWill: '尋找最適合我的平安紙服務',
    },
};
